import React from "react";
import Table from "../../components/subcomponents/table";
import TableControl from "../../components/subcomponents/table_control";
import Button from "../../components/subcomponents/controls/button";
import InputField from "../../components/subcomponents/controls/inputfield";
import ToggleField from "../../components/subcomponents/controls/togglefield";
import CheckField from "../../components/subcomponents/controls/checkfield";
import { connect } from "react-redux";
import companies from "../../api/companies";
import notification from "../../components/subcomponents/notification";
import SubformDetails from "../../components/subcomponents/subform_details";
import FormHeader from "../../components/subcomponents/formheader";

class companiesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allow_to_edit: false,
      edit_rec: false,
      new_rec: false,
    };
  }
  componentWillMount() {
    companies.list();
    this.props.handleSelect();
  }
  selectItem(id) {
    if (this.state.new_rec || this.state.allow_to_edit) {
      notification.error("New/edit rec mode, please cancel before select");
      return null;
    }
    if (id) {
      this.setState({ edit_rec: true });
      this.setState({ allow_to_edit: false });
      this.props.handleSelect(id);
      companies.details();
    } else {
      this.cancel();
    }
  }
  cancel() {
    this.setState({ new_rec: false });
    this.setState({ edit_rec: false });
    this.setState({ allow_to_edit: false });
    this.props.handleSelect();
    companies.list();
  }
  newRec() {
    this.props.handleSelect();
    this.setState({ new_rec: true });
  }
  saveRec() {
    let self = this;
    if (this.state.edit_rec) {
      companies.update((error) => {
        if (!error) {
          companies.list();
          self.cancel();
        }
      });
    } else {
      companies.add(function (error) {
        if (!error) {
          companies.list();
          self.cancel();
        }
      });
    }
  }
  deleteRec() {
    let self = this;
    companies.del(function (error) {
      if (!error) {
        companies.list();
        self.cancel();
      }
    });
  }
  allowEdit(params) {
    this.setState({ allow_to_edit: params.value });
  }
  showDetails() {
    let details_title = this.state.edit_rec
      ? "Admin details"
      : "Enter new admin";
    let save_btn_label = this.state.edit_rec ? "Update " : "Add new";
    let confirm_toggle_status = !this.state.new_rec ? "enabled" : "hidden";

    let save_btn = this.props.company_details.company_name
      ? "enabled"
      : "disabled";
    if (this.state.edit_rec && !this.state.allow_to_edit) save_btn = "hidden";

    let del_btn =
      this.state.edit_rec && this.state.allow_to_edit ? "enabled" : "hidden";

    let inputs_enabled =
      this.state.allow_to_edit || this.state.new_rec ? "enabled" : "disabled";

    //TODO: refactor
    return (
      <SubformDetails
        is_hidden={!this.state.new_rec && !this.state.edit_rec}
        title={details_title}
        className="details width_50"
      >
        <CheckField
          status={confirm_toggle_status}
          name="allow_to_edit"
          label="Enable edit"
          onChange={this.allowEdit.bind(this)}
          value={this.state.allow_to_edit}
        />
        <InputField
          status={inputs_enabled}
          name="company_name"
          label="Name (4-50 chars)"
          onChange={this.props.fieldChange}
          value={this.props.company_details.company_name}
          error={this.props.companies_validation["company_name"]}
        />
        <InputField
          status={inputs_enabled}
          name="contact_person"
          label="Contact (4-30 chars)"
          onChange={this.props.fieldChange}
          value={this.props.company_details.contact_person}
          error={this.props.companies_validation["contact_person"]}
        />
        <InputField
          status={inputs_enabled}
          name="email"
          label="Contact (9-15 chars)"
          onChange={this.props.fieldChange}
          value={this.props.company_details.email}
          error={this.props.companies_validation["email"]}
        />
        <InputField
          status={inputs_enabled}
          name="phone"
          label="Contact (9-15 chars)"
          onChange={this.props.fieldChange}
          value={this.props.company_details.phone}
          error={this.props.companies_validation["phone"]}
        />
        <ToggleField
          status={inputs_enabled}
          name="allow_dashboard"
          label="Allow dashboard"
          onChange={this.props.fieldChange}
          value={this.props.company_details.allow_dashboard}
        />
        <div className="toolbar">
          <Button
            name="add"
            label={save_btn_label}
            onClick={this.saveRec.bind(this)}
            status={save_btn}
          />
          <Button
            name="delete"
            label="Delete"
            onClick={this.deleteRec.bind(this)}
            status={del_btn}
          />
          <Button
            name="cancel"
            label="Cancel"
            onClick={this.cancel.bind(this)}
          />
        </div>
      </SubformDetails>
    );
  }
  render() {
    let new_btn = this.state.edit_rec ? "hidden" : "enabled";
    return (
      <div className="form_wrap admin_list">
        <FormHeader title="COMPANIES LIST" />
        <SubformDetails className="master width_50">
          <TableControl
            search={this.props.search_string}
            handleSearch={this.props.handleSearch}
          />
          <Table
            name="companies_list"
            table_key={"company_id"}
            handleSelect={this.selectItem.bind(this)}
            selected={this.props.company_selected}
            headers={{
              company_id: { label: "ID", width: "5%" },
              company_name: { label: "Name", width: "30%" },
              contact_person: { label: "Person", width: "20%" },
              email: { label: "Email", width: "15%" },
              phone: { label: "Phone", width: "10%" },
              allow_dashboard: { label: "Allow dashboard", width: "15%" },
            }}
            data={this.props.companies_list}
          />
          <Button
            name="new"
            label="New company"
            onClick={this.newRec.bind(this)}
            status={new_btn}
          />
        </SubformDetails>
        {this.showDetails()}
      </div>
    );
  }
}

/**
 * [Converts plain obj to arr for state]
 * @param obj
 */
function stateArr(obj = {}) {
  let state_arr = [];
  Object.keys(obj).forEach((field) => {
    state_arr.push(obj[field]);
  });
  return state_arr;
}

function mapStateToProps(state) {
  let companies = state.companiesR.companies;

  return {
    search_string: companies.search_string,
    companies_list: companies.list,
    company_selected: companies.selected,

    company_details: companies.details,
    company_state: stateArr(companies.detail),

    companies_validation: companies.validation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleSearch(result) {
      dispatch({
        type: "COMPANIES_DESELECTED",
      });
      dispatch({
        type: "COMPANIES_UPDATE_SEARCH_STRING",
        value: result.value,
      });
      companies.list();
    },
    handleSelect(id) {
      if (id) {
        dispatch({
          type: "COMPANIES_SELECTED",
          value: id,
        });
      } else {
        dispatch({
          type: "COMPANIES_DESELECTED",
        });
      }
    },
    cancelSelect() {
      dispatch({
        type: "COMPANIES_CANCEL_SELECT",
      });
    },
    fieldChange(result) {
      dispatch({
        type: "COMPANIES_UPDATE_FORM",
        field: result.name,
        value: result.value,
      });
    },
  };
}

export default companiesList = connect(
  mapStateToProps,
  mapDispatchToProps
)(companiesList);
